import { useContext, useState, useEffect } from "react";

import { StyleSheet, View, Text, ScrollView } from "react-native";
import SafeAreaView from "../components/SafeAreaView";

import CustomButton from "../components/CustomButton";
import { AuthContext } from "../context/AuthContext";
import PageHeader from "../components/PageHeader";
import * as Config from "../config";
import { EventRegister } from "react-native-event-listeners";
import { ChipType, dateValue, getSchemeStyle } from "../context/helper";

const BoardInfoValue = (props) => {
  return (
    <View style={props.style}>
      <View style={valueStyles.mainContainer}>
        <Text
          style={[
            valueStyles.col1,
            {
              width: props.titleWidth ?? valueStyles.col1.width,
              color: props.style ? props.style.color : undefined,
            },
          ]}
        >
          {props.title}
        </Text>
        <Text style={{ color: props.style ? props.style.color : undefined }}>
          {props.value}
        </Text>
      </View>
    </View>
  );
};

const valueStyles = StyleSheet.create({
  mainContainer: {
    flexDirection: "row",
  },
  col1: {
    width: 130,
    fontFamily: "Roboto-Bold",
    fontSize: 14,
  },
  col2: {
    fontFamily: "Roboto-Regular",
    fontSize: 14,
  },
});

const BoardInfoScreen = ({ navigation }) => {
  const schemeStyles = getSchemeStyle();

  const [dataLoaded, setDataLoaded] = useState(false);
  const { logout, serviceBoardInfo, setServiceBoardInfo } =
    useContext(AuthContext);

  const firmInfo = () => {
    return serviceBoardInfo.firmid === 0
      ? "Keinem Unternehmen zugeordnet"
      : serviceBoardInfo.firmname;
  };
  const messInfo = () => {
    return serviceBoardInfo.messid === 0
      ? "- Messstelle nicht zugewiesen -"
      : serviceBoardInfo.messname;
  };
  const intervalMinutes = () => {
    return Math.floor(serviceBoardInfo.interval / 60);
  };
  const intervalHours = () => {
    return Math.floor(intervalMinutes() / 6) / 10;
  };

  useEffect(() => {
    const emitSubscribe = EventRegister.addEventListener(
      Config.Events.BOARD_CHANGE,
      (msg) => {
        if (serviceBoardInfo.id === msg.boardid) {
          setServiceBoardInfo({
            ...serviceBoardInfo,
            firmid: msg.firmid,
            messid: msg.messid,
            interval: msg.interval * 60,
            bssid: msg.bssid,
            firmname: msg.firmname,
            branchname: msg.branchname,
            messname: msg.sensorname,
          });
        }
      }
    );
    return () => {
      EventRegister.removeEventListener(emitSubscribe);
    };
  }, [serviceBoardInfo, setServiceBoardInfo]);

  const prodDate = (date) => {
    if (new Date(date).getTime() == -3600000) return "unbekannt";
    else return dateValue(date);
  };
  return (
    <SafeAreaView style={[styles.mainArea, schemeStyles.Background]}>
      <PageHeader navigation={navigation} />
      <ScrollView style={styles.mainContainer}>
        <View>
          <Text style={[styles.titleText, schemeStyles.grayText]}>
            Info Sensorbox
          </Text>
        </View>
        <View>
          <Text
            style={[styles.sensorText, schemeStyles.defaultText]}
          >{`Sensorbox #${serviceBoardInfo.id}`}</Text>
          <Text style={[styles.firmText, schemeStyles.defaultText]}>
            {firmInfo()}
          </Text>
          <Text
            style={[
              styles.tokenText,
              schemeStyles.defaultText,
              schemeStyles.BorderC,
            ]}
          >
            {serviceBoardInfo.token}
          </Text>
          <BoardInfoValue
            style={schemeStyles.defaultText}
            title={"Chiptyp:"}
            value={ChipType.chipName(serviceBoardInfo.chiptype)}
          />
          <BoardInfoValue
            style={schemeStyles.defaultText}
            title={"Produktionsdatum:"}
            value={prodDate(serviceBoardInfo.producedate)}
          />
          <BoardInfoValue
            style={schemeStyles.defaultText}
            title={"Sendeintervall:"}
            value={`${intervalHours()}h (${intervalMinutes()}min)`}
          />
          <BoardInfoValue
            style={schemeStyles.defaultText}
            title={"Router MAC:"}
            value={serviceBoardInfo.bssid}
          />
          <View style={[styles.messContainer,schemeStyles.BorderC]}>
            <Text style={[styles.messHeader,schemeStyles.defaultText]}>
              {`Messstelle`}
              {serviceBoardInfo.messid != 0 && ` #${serviceBoardInfo.messid}`}
            </Text>
            {serviceBoardInfo.branchname && (
              <BoardInfoValue
              style={schemeStyles.defaultText}
              titleWidth={100}
                title={"Filiale:"}
                value={serviceBoardInfo.branchname}
              />
            )}
            <BoardInfoValue
            style={schemeStyles.defaultText}
            titleWidth={100}
              title={"Bezeichnung:"}
              value={messInfo()}
            />
          </View>
        </View>
        <View style={styles.buttonContainer}>
          <CustomButton
            style={[styles.buttons, styles.backButton, schemeStyles.buttonText]}
            onPress={() => {
              logout();
            }}
          >
            Abmelden
          </CustomButton>
          <View style={styles.spacer} />
          <CustomButton
            style={[styles.buttons,schemeStyles.buttonText]}
            onPress={() => {
              navigation.navigate("BoardScreen", {
                boardid: serviceBoardInfo.id,
                changepoint: true,
              });
            }}
          >
            Ändern
          </CustomButton>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default BoardInfoScreen;

const styles = StyleSheet.create({
  mainArea: {
    flex: 1,
    paddingTop: 20,
  },
  mainContainer: {
    paddingHorizontal: 25,
  },
  titleText: {
    fontFamily: "Roboto-Medium",
    fontSize: 28,
    fontWeight: "500",
    color: "#333",
    marginBottom: 30,
  },
  sensorText: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
  },
  firmText: {
    fontFamily: "Roboto-Regular",
    fontSize: 16,
    marginBottom: 5,
  },
  tokenText: {
    fontFamily: "Roboto-Regular",
    fontSize: 16,
    marginBottom: 10,
    paddingBottom: 10,
    borderBottomWidth: 1,
  },
  messContainer: {
    borderTopWidth: 1,
    marginTop: 10,
    paddingTop: 10,
    borderBottomWidth: 1,
    marginBottom: 10,
    paddingBottom: 10,
  },
  messHeader: {
    fontFamily: "Roboto-Regular",
    fontSize: 16,
  },
  buttonContainer: {
    flexDirection: "row",
  },
  buttons: {
    flex: 1,
  },
  backButton: {
    backgroundColor: "#555",
  },
  spacer: {
    width: 10,
  },
});
